export enum UserType {
  Farmer = 'Farmer',
  Internal = 'Internal',
  RetailerAdmin = 'Retailer Admin',
  SalesPerson = 'SalesPerson',
}
